import { ArrowWrap } from './PriceIndicator.styled'

const getColor = ({ isArrowUp }) => {
  if (isArrowUp) {
    return '#15CDAC'
  }

  return '#CE3C3C'
}

export const Arrow = ({ isArrowUp, isCollapsed }) => {
  const fillColor = getColor({ isArrowUp })

  return (
    <ArrowWrap $isArrowUp={isArrowUp} $isCollapsed={isCollapsed}>
      <svg width="8" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.32609 5.13254L7 8L5.95652 8L4.0163 5.80043L4.08152 5.81824L3.91848 5.81824L3.9837 5.80043L2.04348 8L1 8L3.67391 5.13254L4.32609 5.13254Z"
          fill={fillColor}
        />
        <path
          d="M4.32609 1L7 3.86746L5.95652 3.86746L4.0163 1.66789L4.08152 1.6857L3.91848 1.6857L3.9837 1.66789L2.04348 3.86746L1 3.86746L3.67391 1L4.32609 1Z"
          fill={fillColor}
        />
        <path
          d="M4.32609 5.13254L7 8L5.95652 8L4.0163 5.80043L4.08152 5.81824L3.91848 5.81824L3.9837 5.80043L2.04348 8L1 8L3.67391 5.13254L4.32609 5.13254Z"
          stroke={fillColor}
          strokeWidth="0.5"
        />
        <path
          d="M4.32609 1L7 3.86746L5.95652 3.86746L4.0163 1.66789L4.08152 1.6857L3.91848 1.6857L3.9837 1.66789L2.04348 3.86746L1 3.86746L3.67391 1L4.32609 1Z"
          stroke={fillColor}
          strokeWidth="0.5"
        />
      </svg>
    </ArrowWrap>
  )
}
